import { Search } from "../../../search/Search.js";
import { SearchRequest } from "../../../search/SearchRequest.js";


/**
 * A function for doing a search request in the elasticsearch index
 * 
 * @param {string[]} args indices seperated by comma, query, geometry
 * @returns {string} container for search results
 * 
 * @memberof vef.map.popup.templateFunctions
 */
export function lto(args, data, postProcessingQueue) {
    const id = `lto_${postProcessingQueue.length}`;

    const lat = parseFloat(args[0]);
    const lng = parseFloat(args[1]);

    postProcessingQueue.push(container => {
        const target = container.querySelector("#" + id);

        const searchInstance = new Search("https://marine-data.de/rest/search/");
        searchInstance.on("finished", e => {
            for (let facet of e.facets) {
                const div = document.createElement("div");
                div.style.width = "410px";
                target.insertAdjacentHTML("beforeend", "<h3>" + facet.label + "</h3>")
                target.appendChild(div);
                const data = [
                    {
                        y: facet.children.map(child => child.label),
                        x: facet.children.map(child => child.value),
                        type: 'bar',
                        orientation: 'h',
                        font: {
                            family: 'Arial',
                            size: 12
                        }
                    }
                ];
                Plotly.newPlot(div, data);
            }
            target.innerHTML += "<div>Total Hits: <b>" + e.totalHits + "</b></div>"
        });

        const request = new SearchRequest("harvest");
        request.excludes = ['metadata', 'keywords.region*', 'keywords.vmap*'];
        request.hits = 0;
        request.facets = [
            "platforms.name:10",
            "persons.author.fullname:10",
            "devices.name:10",
            "expeditions:10",
            "parameters.name:10"
        ]
        request.query = "organisations.provider.abbreviation:(PANGAEA)";
        request.queryGeometries.geometry = [{
            coordinates: [[
                [lng - 0.5, lat - 0.5],
                [lng - 0.5, lat + 0.5],
                [lng + 0.5, lat + 0.5],
                [lng + 0.5, lat - 0.5],
                [lng - 0.5, lat - 0.5]
            ]],
            type: "Polygon"
        }];

        searchInstance.request(request);
    });

    return `<div id="${id}"></div>`;
}